import { render, staticRenderFns } from "./CidadaoIcon.vue?vue&type=template&id=71ff52ac"
import script from "./CidadaoIcon.vue?vue&type=script&lang=js"
export * from "./CidadaoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports